import { EnvironmentModel } from './environment.model'

export function env(): EnvironmentModel {
  return {
    stage: 'env-demo',
    api: {
      url: 'https://demo-patientenselfservice-restbackend-f2c3apere3axdzgf.germanywestcentral-01.azurewebsites.net/api',
    },
  }
}
